import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";

import CMSLogin from "@/views/cms/Login.vue";
import CMS from "@/views/cms/CMS.vue";

const routes = [
  {
    path: "/login",
    name: "廠商後台登入",
    component: CMSLogin,
    meta: { title: "登入 | Quarter Car Part.廠商後台" }
  },
  {
    path: "/",
    component: CMS,
    children: [
      {
        path: "",
        meta: { title: "Quarter Car Part.廠商平台" },
        redirect: {
          name: "訂單管理"
        }
      },
      {
        path: "product",
        name: "商品管理",
        component: () => import("@/components/cms/Product.vue"),
        meta: {
          title: "商品管理 | Quarter Car Part.廠商平台"
        },
        props: route => ({
          search: route.query.search,
          part_brand: route.query.part_brand,
          part_category: route.query.part_category,
          card_type: route.query.card_type,
          card_brand: route.query.card_brand,
          card_model: route.query.card_model,
          card_year: route.query.card_year
        })
      },
      {
        path: "zone",
        name: "業務區域管理",
        component: () => import("@/components/cms/Zone.vue"),
        meta: {
          title: "業務區域管理 | Quarter Car Part.廠商平台"
        },
        props: route => ({ search: route.query.search })
      },
      {
        path: "account",
        component: () => import("@/components/cms/Account.vue"),
        children: [
          {
            path: "",
            meta: {
              title: "帳號管理 | Quarter Car Part.管理者平台"
            },
            redirect: {
              name: "業務"
            }
          },
          {
            path: "salesman",
            name: "業務",
            meta: {
              title: "業務 | Quarter Car Part.管理者平台"
            },
            component: () => import("@/components/cms/Salesman.vue")
          },
          {
            path: "admin",
            name: "管理者",
            meta: {
              title: "管理者 | Quarter Car Part.管理者平台"
            },
            component: () => import("@/components/cms/Admin.vue")
          }
        ]
      },
      {
        path: "order",
        name: "訂單管理",
        component: () => import("@/components/cms/Order.vue"),
        meta: {
          title: "訂單管理 | Quarter Car Part.廠商平台"
        },
        props: route => ({ search: route.query.search })
      },
      {
        path: "report",
        name: "報表",
        component: () => import("@/components/cms/Report.vue"),
        meta: {
          title: "報表 | Quarter Car Part.廠商平台"
        }
      },
      {
        path: "*",
        name: "該頁無法顯示",
        component: () => import("@/components/NotFoundComponent.vue"),
        meta: { title: "404 Error | Quarter Car Part.廠商平台" }
      }
    ]
  }
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base:
    process.env.BASE_URL +
    (process.env.NODE_ENV === "development" ? "cms/" : ""),
  routes
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.beforeEach(async (to, from, next) => {
  const cmsToken = localStorage.getItem("cms-api_token");
  const hasLogin = !!cmsToken && cmsToken != "undefined";
  window.document.title = to.meta.title;
  if (to.path == "/login") {
    if (hasLogin) {
      next({ name: "訂單管理" });
    } else {
      next();
    }
  } else {
    if (hasLogin) {
      next();
    } else {
      next({ name: "廠商後台登入" });
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

router.onError(error => {
  if (/Loading chunk \d* failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router;
